import MaterialTable from '@material-table/core'
import ProfileWidget from '@shared/profile-widget'
import React, { useEffect, useState } from 'react'
import Table from '@components/shared/table'
import { CircularProgress, Paper } from '@mui/material'
import { fetchDisplayedUsers } from '@store/actions/currently-displayed-users'
import { makeStyles } from 'tss-react/mui'
import {
  selectCurrentlyDisplayedUsers,
  selectTotalDisplayableUsers,
} from '@store/selectors/currently-displayed-users'
import { selectPermissionById, selectRoles } from '@store/selectors'
import { useAllActions, useSelector } from '@hooks'
import { useDispatch } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'

const useStyles = makeStyles()((theme) => ({
  section: {
    marginBottom: theme.spacing(2),
    display: 'flex',
    justifyContent: 'space-between',
  },
  roles: {
    marginRight: theme.spacing(2),
    width: '430px',
  },
  users: {
    width: '100%',
  },
}))

const Permission = () => {
  const { id } = useParams()
  const { classes } = useStyles()
  const { getRoles, getPermission } = useAllActions()
  const dispatch = useDispatch()
  const [userRowsPerPage, setUserRowsPerPage] = useState(10)
  const [userPage, setUserPage] = useState(0)

  const permission = useSelector((state) => selectPermissionById(state, id))
  const totalUsers = useSelector(selectTotalDisplayableUsers)
  const users = useSelector(selectCurrentlyDisplayedUsers)
  const roles = useSelector(selectRoles)

  const navigate = useNavigate()

  useEffect(() => {
    getRoles()
    getPermission(id)
  }, [])

  useEffect(() => {
    if (permission) {
      dispatch(
        fetchDisplayedUsers(userPage, userRowsPerPage, {
          permission_id: permission.id,
        }),
      )
    }
  }, [permission, userRowsPerPage, userPage])

  if (!roles || !permission || !users) return <CircularProgress />

  const permissionRoles = Object.values(roles).filter((role) => {
    return role?.permission_ids?.includes(permission.id)
  })

  return (
    <div>
      <ProfileWidget
        subtitle1={permission.description}
        title={permission.permission}
      />
      <div className={classes.section}>
        <div className={classes.roles}>
          <MaterialTable
            columns={[{ title: '', field: 'role', defaultSort: 'asc' }]}
            data={permissionRoles}
            onRowClick={(_, row) => {
              navigate(`/roles/${row.id}`)
            }}
            options={{
              paging: false,
              search: false,
              sorting: true,
            }}
            title='Roles'
          />
        </div>
        <div className={classes.users}>
          <Paper>
            <Table
              columns={[
                { title: 'Name', field: 'name' },
                { title: 'Email', field: 'email' },
              ]}
              count={totalUsers}
              data={users}
              onPageChange={setUserPage}
              onRowClick={(row) => `/users/${row.id}`}
              onRowsPerPageChange={setUserRowsPerPage}
              paginated
              title='Users with this permission both directly or through a role'
            />
          </Paper>
        </div>
      </div>
    </div>
  )
}

export default Permission
